import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import Sample from 'repos/Sample.js';
import {connect} from 'react-redux';
import {
    getTitlesForSounds,
    getSoundsWithTag,
    } from 'search/getSounds.js';

const GuitarAmpComponent = ({effect, effectNumber, sequencerEngine}) => { 
    let [sample, setSample] = useState(undefined);
    let [samples, setSamples] = useState([]);
    let [convolverSample, setConvolverSample] = useState(effect.convolver.convolverSample);

    useEffect(() => {
        if (effect.convolver.convolverSample !== convolverSample) {
            setConvolverSample(effect.convolver.convolverSample);
        }
    }, [effect.convolver.convolverSample, setConvolverSample, convolverSample]);

    useEffect(() => {
        if (convolverSample === undefined) {
            return;
        }
        let sample = new Sample(effect.convolver.convolverSample);
        sample.load(false).then(() => {
            setSample(sample);
        });
    }, [effect, convolverSample, setSample]);

    useEffect(() => {
        getSoundsWithTag("guitar amp")
            .then(x => {
                getTitlesForSounds(x).then(
                    y => setSamples(y));
            });
    }, [setSamples]);

    const onClickSample = useCallback(async (id) => {
        await effect.convolver.setConvolverSample(id);
        setConvolverSample(id);
    }, [effect, setConvolverSample]);

    if (sample === undefined) {
        return [];
    }

    let tags = sample.tags || [];
    return (
        <div className="guitar-amp">
          <div className="amp-name">{sample.name}</div>
          <div className="amp-tags">
            {tags.map(x => <div key={x} className="amp-tag">{x}</div>)}
          </div>
                       <EffectParameterSlider
                         effectNumber={effectNumber}
                         automation={undefined}
                         name='Tone'
                         parameter={effect.convolver.pitchParameter}
                         isParameter={true}
                         onParameterChanged={() => []}
                         step={0.1}
                         max={24}
                        min={-24}
                       />
          <div className="amps-list">
            {samples.map(
                (x, i) =>
                    <div
                      key={i}
                      onClick={() => onClickSample(x.ipfsHash)}
                      className={x.ipfsHash === sample.ipfsHash ? "amp-option selected" : "amp-option"}>
                      {x.title}
                    </div>)}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      convolverSample: props.effect.convolver.convolverSample ,
      wet: props.effect.convolver.wetParameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GuitarAmpComponent);
